var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('fieldset', {
    staticClass: "RadioButtonList"
  }, [_c('legend', {
    staticClass: "RadioButtonList-legend"
  }, [_vm._v(" " + _vm._s(_vm.ariaLabel) + " ")]), _vm._l(_vm.items, function (item, index) {
    return _c('div', {
      key: ("radio-button-list_" + index),
      staticClass: "RadioButtonList-item",
      attrs: {
        "role": "radiogroup",
        "tabindex": "-1"
      },
      on: {
        "click": function ($event) {
          return _vm.updateValue(item.id);
        },
        "keyup": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
          return _vm.validateValue();
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.currentValue,
        expression: "currentValue"
      }],
      staticClass: "RadioButtonList-input u-clientColor",
      attrs: {
        "id": item.id,
        "aria-checked": _vm.currentValue === item.id,
        "type": "radio"
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.currentValue, item.id)
      },
      on: {
        "change": function ($event) {
          _vm.currentValue = item.id;
        }
      }
    }), _c('span', {
      staticClass: "RadioButtonList-radioButtonContainer"
    }, [_c('span', {
      staticClass: "RadioButtonList-radioButton",
      class: {
        'RadioButtonList-radioButton--selected': _vm.currentValue === item.id
      }
    })]), _c('label', {
      staticClass: "RadioButtonList-label",
      attrs: {
        "for": item.id
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])]);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }